import { Typography } from 'antd'

const { Title } = Typography

export default function NotFound() {
    return (
        <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
            <Title level={1} className='tti-page-title' style={{ margin: 0 }}>
                404
            </Title>
        </div>
    )
}